import React from "react";
import "./styles/Connection.css";

function Connection() {
  return (
    <div className="button">
      <h3>CONNEXION</h3>
    </div>
  );
}

export default Connection;
